import { render, staticRenderFns } from "./campo-busca.vue?vue&type=template&id=48f5f520&scoped=true"
import script from "./campo-busca.vue?vue&type=script&lang=js"
export * from "./campo-busca.vue?vue&type=script&lang=js"
import style0 from "./campo-busca.vue?vue&type=style&index=0&id=48f5f520&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f5f520",
  null
  
)

export default component.exports